import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
window.store = store;

import DeviceDetector from "device-detector-js";

import VueCountdown from '@chenfengyuan/vue-countdown';

import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
window.toast = toast;

import "@/assets/scss/custom.scss";
import "@/assets/scss/event-design.scss";
import "bootstrap";

import "bootstrap-icons/font/bootstrap-icons.css";

import 'animate.css';

import jQuery from 'jquery';
window.$ = jQuery;

import utils from '../../shared/utils';
window.utils = utils;

import RPC from '../../shared/RPC';
window.RPC = RPC;

import client from './client';
window.client = client;

import network from './network';
window.network = network;

import api from './api';
window.api = api;

import { load_model } from './utils/model-cache';
import default_jersey_model_url from '@/utils/jersey_model';
import { startPresenterRemote } from './utils/presenter-remote';

//import sound from './sound';
//window.sound = sound;
//window.sound.settings.allow_audio = localStorage.getItem("play_audio");
//sound.loadAudioBank([
//    {
//        id: 'example',
//        asset: require('@/assets/sounds/example.mp3')
//    }
//]);
//window.sound.playAudio('example', 10, 600);
//window.sound.pauseAudio('example');

// MODE: event|online (see shared/utils.js APP_MODES). Event mode runs
// entirely over the websocket below; online mode's player-facing flows run
// over the REST API (api.js) instead - see client.js's client_update() and
// network.js's send_reliable() for where the two are kept from interfering.
//
// The server is the single source of truth for this - it used to be a
// client-side build-time env var (VUE_APP_MODE) that had to be hand-kept in
// sync with the server's own MODE setting, and silently drifted out of sync
// (e.g. left on "online" after the server switched back to "event", with
// nothing catching the mismatch). Fetched once at boot, before mounting the
// app or connecting the websocket, so nothing mode-dependent runs on a
// stale/guessed value.
async function boot(){
    // Fire-and-forget - starts fetching the three.js chunk + the jersey
    // .glb in the background as early as possible (a guest doesn't reach
    // Auth.vue's jersey-picker step for a while yet), so Avatar3DPicker's
    // own load_model() call there usually resolves instantly instead of
    // visibly loading. Never awaited: must not delay app.mount/network.connect.
    // Always warms the app-wide DEFAULT model, not whichever one the active
    // season may have uploaded - game.seasons hasn't arrived over the
    // websocket yet at this exact point, so there's no season to read from.
    // Harmless either way: model-cache.js caches by URL, so a season with
    // its own model just loads normally (without this head start) once
    // Avatar3DPicker actually mounts and asks for it.
    load_model(default_jersey_model_url).catch(() => {});

    window.MODE = utils.APP_MODES.EVENT;
    try{
        const result = await api.mode();
        if(result.mode === utils.APP_MODES.ONLINE)
            window.MODE = utils.APP_MODES.ONLINE;
    }catch(ex){
        console.error("No se ha podido determinar el modo del servidor, usando 'event' por defecto.", ex);
    }

    const app = createApp(App);
    app.use(store).use(router);
    //app.component(...<lots of components>);
    app.component(VueCountdown.name, VueCountdown);
    app.mount("#app");
    window.app = app;
    window.router = router;
    app.config.performance = true;
    app.config.devtools = true;

    const deviceDetector = new DeviceDetector();
    const device = deviceDetector.parse(navigator.userAgent);

    window.device = device;

    // Load local storage information.
    window.store.commit("loadLocalStorage");

    // Online mode's session-resume-on-refresh (the REST equivalent of the
    // websocket's CLIENT_JOIN-by-session below) - router/index.js's
    // ONLINE_PLAYER_ROUTES guard awaits this before deciding whether a guest
    // is actually a still-logged-in player, so a hard refresh of a deep link
    // doesn't get bounced to Home while this is still in flight.
    window.ensure_online_identity_checked = Promise.resolve();
    if(window.MODE == utils.APP_MODES.ONLINE && localStorage.getItem("online_session")){
        window.ensure_online_identity_checked = window.api.me()
            .then(function(result){
                window.store.commit("setOnlineUser", result.user);
            })
            .catch(function(){
                localStorage.removeItem("online_session");
            });
    }

    window.network.connect(process.env.VUE_APP_HOST,process.env.VUE_APP_PORT,function(){});

    // The MANAGER big screen doubles as the presenter's: a presentation
    // remote plugged into it turns slides and moves the stage on (see
    // server.js's presenter_step for what each click is allowed to do).
    startPresenterRemote({
        isEnabled: () => window.MODE == utils.APP_MODES.EVENT
            && window.store.state.game.user?.role == utils.USER_ROLES.MANAGER,
        onStep: (direction) => window.network.send(window.RPC.PRESENTER_STEP, { direction }),
    });
}

boot();
